import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';

import type { LinkSectionItem } from '../types';
import Item from './Item';
import { ListItem } from './ListItem';

interface InlineTextLinkSectionListItemProps {
  index: number;
  item: LinkSectionItem;
}

const UnstyledStyledListItem = styled(ListItem)``;

const StyledListItem = (props: ComponentProps<typeof UnstyledStyledListItem>) => (
  <UnstyledStyledListItem
    pr={['sp_16', 'sp_24', null, 'sp_48']}
    py="sp_4"
    width="auto"
    {...props}
  />
);

const InlineTextLinkSectionListItem = ({ index, item }: InlineTextLinkSectionListItemProps) => (
  <StyledListItem data-testid={`link-section-list-item-${index}`}>
    <Item item={item}>
      <span data-testid="link-section-link-label">{item.name}</span>
    </Item>
  </StyledListItem>
);

export default InlineTextLinkSectionListItem;
